module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/hoodie/4-1-4a62010c38bc8249d8cec3b761539bdc.jpg";